document.addEventListener('DOMContentLoaded', () => {
  initAboutTeam();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.about-team')) {
      initAboutTeam();
    }
  });
});

function initAboutTeam() {
  const sections = document.querySelectorAll('.about-team');

  sections.forEach((section) => {
    const overlay = section.querySelector('.about-team__drawer-overlay');
    const drawer = section.querySelector('.about-team__drawer');
    const closeBtn = section.querySelector('.about-team__drawer-close');
    const plusBtns = section.querySelectorAll('.about-team__plus-btn');
    const cards = section.querySelectorAll('.about-team__card');
    const isMobile = window.matchMedia('(max-width: 768px)');

    const drawerPhoto = drawer ? drawer.querySelector('.about-team__drawer-photo') : null;
    const drawerName = drawer ? drawer.querySelector('.about-team__drawer .about-team__name') : null;
    const drawerRole = drawer ? drawer.querySelector('.about-team__drawer .about-team__role') : null;
    const drawerEmail = drawer ? drawer.querySelector('.about-team__drawer-email') : null;
    const drawerBio = drawer ? drawer.querySelector('.about-team__drawer-bio') : null;
    const drawerSocialLinks = drawer ? drawer.querySelector('.about-team__drawer-social-links') : null;
    const drawerSocial = drawer ? drawer.querySelector('.about-team__drawer-social') : null;
    const drawerDividerBio = drawer ? drawer.querySelector('.about-team__drawer-divider--bio') : null;
    const drawerDividerSocial = drawer ? drawer.querySelector('.about-team__drawer-divider--social') : null;

    plusBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (isMobile.matches) return;

        const card = btn.closest('.about-team__card');
        const data = {
          photo: card.dataset.photo,
          name: card.dataset.name,
          role: card.dataset.role,
          email: card.dataset.email,
          bio: card.dataset.bio,
          linkedin: card.dataset.linkedin,
          instagram: card.dataset.instagram,
          website: card.dataset.website,
        };

        populateDrawer(data);
        openDrawer();
      });
    });

    function populateDrawer(data) {
      if (!drawer) return;

      if (drawerPhoto) drawerPhoto.src = data.photo || '';
      if (drawerName) drawerName.textContent = data.name || '';
      if (drawerRole) drawerRole.textContent = data.role || '';
      if (drawerEmail) {
        drawerEmail.textContent = data.email || '';
        drawerEmail.style.display = data.email ? '' : 'none';
      }
      const hasBio = !!(data.bio);
      if (drawerBio) drawerBio.innerHTML = data.bio || '';
      if (drawerDividerBio) drawerDividerBio.style.display = hasBio ? '' : 'none';

      const hasSocials = !!(data.linkedin || data.instagram || data.website);
      if (drawerSocialLinks) {
        drawerSocialLinks.innerHTML = '';
        if (data.linkedin) {
          drawerSocialLinks.appendChild(createSocialLink(data.linkedin, 'LinkedIn', linkedinSVG));
        }
        if (data.instagram) {
          drawerSocialLinks.appendChild(createSocialLink(data.instagram, 'Instagram', instagramSVG));
        }
        if (data.website) {
          drawerSocialLinks.appendChild(createSocialLink(data.website, 'Website', websiteSVG));
        }
      }

      if (drawerSocial) drawerSocial.style.display = hasSocials ? '' : 'none';
      if (drawerDividerSocial) drawerDividerSocial.style.display = hasSocials ? '' : 'none';
    }

    function createSocialLink(url, label, svgHTML) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.className = 'about-team__drawer-social-link';
      a.setAttribute('aria-label', label);
      a.innerHTML = svgHTML;
      return a;
    }

    function openDrawer() {
      if (!overlay || !drawer) return;
      overlay.classList.add('is-active');
      drawer.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');

      if (typeof trapFocus === 'function') {
        trapFocus(drawer);
      }

      document.addEventListener('keydown', onEscapeKey);
    }

    function closeDrawer() {
      if (!overlay || !drawer) return;
      overlay.classList.remove('is-active');
      drawer.classList.remove('is-active');
      document.body.style.overflow = '';

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }

      document.removeEventListener('keydown', onEscapeKey);
    }

    function onEscapeKey(e) {
      if (e.key === 'Escape') {
        closeDrawer();
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    cards.forEach((card) => {
      const toggleBtn = card.querySelector('.about-team__mobile-toggle');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', () => {
          card.classList.toggle('is-expanded');
        });
      }
    });
  });
}

const linkedinSVG =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.25 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V20.25C2.25 20.6478 2.40804 21.0294 2.68934 21.3107C2.97064 21.592 3.35218 21.75 3.75 21.75H20.25C20.6478 21.75 21.0294 21.592 21.3107 21.3107C21.592 21.0294 21.75 20.6478 21.75 20.25V3.75C21.75 3.35218 21.592 2.97064 21.3107 2.68934C21.0294 2.40804 20.6478 2.25 20.25 2.25ZM20.25 20.25H3.75V3.75H20.25V20.25ZM9 10.5V16.5C9 16.6989 8.92098 16.8897 8.78033 17.0303C8.63968 17.171 8.44891 17.25 8.25 17.25C8.05109 17.25 7.86032 17.171 7.71967 17.0303C7.57902 16.8897 7.5 16.6989 7.5 16.5V10.5C7.5 10.3011 7.57902 10.1103 7.71967 9.96967C7.86032 9.82902 8.05109 9.75 8.25 9.75C8.44891 9.75 8.63968 9.82902 8.78033 9.96967C8.92098 10.1103 9 10.3011 9 10.5ZM17.25 13.125V16.5C17.25 16.6989 17.171 16.8897 17.0303 17.0303C16.8897 17.171 16.6989 17.25 16.5 17.25C16.3011 17.25 16.1103 17.171 15.9697 17.0303C15.829 16.8897 15.75 16.6989 15.75 16.5V13.125C15.75 12.6277 15.5525 12.1508 15.2008 11.7992C14.8492 11.4475 14.3723 11.25 13.875 11.25C13.3777 11.25 12.9008 11.4475 12.5492 11.7992C12.1975 12.1508 12 12.6277 12 13.125V16.5C12 16.6989 11.921 16.8897 11.7803 17.0303C11.6397 17.171 11.4489 17.25 11.25 17.25C11.0511 17.25 10.8603 17.171 10.7197 17.0303C10.579 16.8897 10.5 16.6989 10.5 16.5V10.5C10.5009 10.3163 10.5693 10.1393 10.692 10.0026C10.8148 9.86596 10.9834 9.7791 11.166 9.75852C11.3485 9.73794 11.5323 9.78508 11.6824 9.891C11.8325 9.99691 11.9385 10.1542 11.9803 10.3331C12.4877 9.98894 13.0792 9.78947 13.6914 9.75611C14.3036 9.72276 14.9133 9.85679 15.455 10.1438C15.9968 10.4308 16.4501 10.86 16.7664 11.3852C17.0826 11.9105 17.2498 12.5119 17.25 13.125ZM9.375 7.875C9.375 8.0975 9.30902 8.31501 9.1854 8.50002C9.06179 8.68502 8.88609 8.82922 8.68052 8.91436C8.47495 8.99951 8.24875 9.02179 8.03052 8.97838C7.81229 8.93498 7.61184 8.82783 7.4545 8.6705C7.29717 8.51316 7.19002 8.31271 7.14662 8.09448C7.10321 7.87625 7.12549 7.65005 7.21064 7.44448C7.29578 7.23891 7.43998 7.06321 7.62498 6.9396C7.80999 6.81598 8.0275 6.75 8.25 6.75C8.54837 6.75 8.83452 6.86853 9.0455 7.0795C9.25647 7.29048 9.375 7.57663 9.375 7.875Z" fill="currentColor"/></svg>';

const instagramSVG =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.5C11.11 7.5 10.24 7.76392 9.49993 8.25839C8.75991 8.75285 8.18314 9.45566 7.84254 10.2779C7.50195 11.1002 7.41283 12.005 7.58647 12.8779C7.7601 13.7508 8.18868 14.5526 8.81802 15.182C9.44736 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0243 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 15C11.4067 15 10.8266 14.8241 10.3333 14.4944C9.83994 14.1648 9.45542 13.6962 9.22836 13.1481C9.0013 12.5999 8.94189 11.9967 9.05764 11.4147C9.1734 10.8328 9.45912 10.2982 9.87868 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.1481 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.8241 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15ZM16.5 2.25H7.5C6.10807 2.25149 4.77358 2.80509 3.78933 3.78933C2.80509 4.77358 2.25149 6.10807 2.25 7.5V16.5C2.25149 17.8919 2.80509 19.2264 3.78933 20.2107C4.77358 21.1949 6.10807 21.7485 7.5 21.75H16.5C17.8919 21.7485 19.2264 21.1949 20.2107 20.2107C21.1949 19.2264 21.7485 17.8919 21.75 16.5V7.5C21.7485 6.10807 21.1949 4.77358 20.2107 3.78933C19.2264 2.80509 17.8919 2.25149 16.5 2.25ZM20.25 16.5C20.25 17.4946 19.8549 18.4484 19.1516 19.1516C18.4484 19.8549 17.4946 20.25 16.5 20.25H7.5C6.50544 20.25 5.55161 19.8549 4.84835 19.1516C4.14509 18.4484 3.75 17.4946 3.75 16.5V7.5C3.75 6.50544 4.14509 5.55161 4.84835 4.84835C5.55161 4.14509 6.50544 3.75 7.5 3.75H16.5C17.4946 3.75 18.4484 4.14509 19.1516 4.84835C19.8549 5.55161 20.25 6.50544 20.25 7.5V16.5ZM18 7.125C18 7.3475 17.934 7.56501 17.8104 7.75002C17.6868 7.93502 17.5111 8.07922 17.3055 8.16436C17.1 8.24951 16.8738 8.27179 16.6555 8.22838C16.4373 8.18498 16.2368 8.07783 16.0795 7.9205C15.9222 7.76316 15.815 7.56271 15.7716 7.34448C15.7282 7.12625 15.7505 6.90005 15.8356 6.69448C15.9208 6.48891 16.065 6.31321 16.25 6.1896C16.435 6.06598 16.6525 6 16.875 6C17.1734 6 17.4595 6.11853 17.6705 6.3295C17.8815 6.54048 18 6.82663 18 7.125Z" fill="currentColor"/></svg>';

const websiteSVG =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.747 9.41505 20.7188 6.93683 18.891 5.109C17.0632 3.28116 14.585 2.25298 12 2.25ZM20.2144 11.25H16.4803C16.3125 7.82719 14.9944 5.40656 13.9134 3.975C15.5918 4.37804 17.102 5.29628 18.2321 6.60095C19.3623 7.90562 20.0558 9.53129 20.2153 11.25H20.2144ZM9.02157 12.75H14.9784C14.7619 16.6509 12.8944 19.0416 12 19.9688C11.1047 19.0406 9.23813 16.65 9.02157 12.75ZM9.02157 11.25C9.23813 7.34906 11.1056 4.95844 12 4.03125C12.8953 4.96219 14.7619 7.35281 14.9784 11.25H9.02157ZM10.0866 3.975C9.00563 5.40656 7.6875 7.82719 7.51969 11.25H3.78469C3.94425 9.53129 4.63773 7.90562 5.76788 6.60095C6.89804 5.29628 8.40819 4.37804 10.0866 3.975ZM3.78469 12.75H7.51969C7.69032 16.1728 9.00563 18.5934 10.0866 20.025C8.40819 19.622 6.89804 18.7037 5.76788 17.399C4.63773 16.0944 3.94425 14.4687 3.78469 12.75ZM13.9097 20.025C14.9906 18.5934 16.3059 16.1728 16.4766 12.75H20.2116C20.0522 14.4682 19.3593 16.0935 18.2299 17.3981C17.1005 18.7027 15.5911 19.6213 13.9134 20.025H13.9097Z" fill="currentColor"/></svg>';
